import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/museum-app/utils/cn';

interface MediaLoadingPlaceholderProps {
  height?: string;
  icon?: React.ElementType;
  children?: React.ReactNode; // Accept children (e.g., the button)
  className?: string;
}

export const MediaLoadingPlaceholder: React.FC<MediaLoadingPlaceholderProps> = ({
    height = 'h-[400px]',
    icon: Icon,
    children, // Use children prop
    className = ''
}) => (
    // Simplified className assignment for diagnostics - removed cn()
    <div className={`relative w-full ${height} ${className}`}>
        <Skeleton className="h-full w-full rounded-lg" />
        <div className="absolute inset-0 flex flex-col items-center justify-center rounded-lg bg-black/10 dark:bg-black/30">
            {Icon && <Icon className="h-16 w-16 text-white/50" />}
            {/* Render children (which will be the button) */}
            {children}
        </div>
    </div>
);
